import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type NetworkPermissionsQueryVariables = GraphQLTypes.Exact<{
  networkId: GraphQLTypes.Scalars['String']['input'];
}>;

export type NetworkPermissionsQueryResult = { __typename?: 'Query' } & {
  network?: GraphQLTypes.Maybe<
    { __typename?: 'Network' } & {
      canCreateAgentOrganisation: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      canCreateForwarderOrganisation: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      canCreateSavedOrganisation: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
    }
  >;
};

export const NetworkPermissionsQueryDocument = gql`
  query networkPermissionsQuery($networkId: String!) {
    network(id: $networkId) {
      canCreateAgentOrganisation {
        value
      }
      canCreateForwarderOrganisation {
        value
      }
      canCreateSavedOrganisation {
        value
      }
    }
  }
`;
